import { Link } from "react-router-dom";
import { Compass, ChevronLeft } from "lucide-react";

import { SHOW_PREVIEW_BADGE } from "@/lib/environment";
import { useI18n } from "@/i18n/I18nContext";
import { useMemberAuth } from "../MemberAuthContext";

export default function NotFound() {
  const { t } = useI18n();
  const { member } = useMemberAuth();
  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden" data-testid="member-not-found"
      style={{ background: "linear-gradient(160deg, #2A1650 0%, #3A1F6B 45%, #8A1E63 100%)" }}>
      <header className="relative z-10 px-5 py-4">
        <img src="/visibilis-logo.png" alt="Visibilis Life" className="h-12 w-auto" />
      </header>
      <main className="relative z-10 flex flex-1 items-center justify-center px-4 py-8">
        <div className="w-full max-w-[420px] text-center">
          <span className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-white/10 text-white backdrop-blur">
            <Compass className="h-7 w-7" aria-hidden="true" />
          </span>
          <h1 className="text-3xl font-bold text-white" data-testid="member-not-found-title">{t("member.not_found.title")}</h1>
          <p className="mt-2 text-white/70" data-testid="member-not-found-text">{t("member.not_found.text")}</p>
          <Link to={member ? "/" : "/login"} replace data-testid={member ? "member-not-found-back-home" : "member-not-found-back-login"}
            className="mt-6 inline-flex h-12 items-center justify-center gap-2 rounded-xl px-6 text-[17px] font-semibold text-white transition-transform active:scale-[0.99]"
            style={{ background: "linear-gradient(95deg, #E0106F 0%, #FF2F97 100%)", boxShadow: "0 14px 40px rgba(255,47,151,0.35)" }}>
            <ChevronLeft className="h-5 w-5" aria-hidden="true" />{member ? "Zur Startseite" : t("member.not_found.back")}
          </Link>
          {SHOW_PREVIEW_BADGE && (
            <p className="mt-5 text-xs font-semibold uppercase tracking-wide text-white/50" data-testid="member-not-found-preview-badge">{t("member.login.preview_badge")}</p>
          )}
        </div>
      </main>
    </div>
  );
}
